// Mirrors landing's BOOKING_URL (frontend/landing/src/lib/contact.ts).
export const BOOKING_URL = "https://cal.com/condense.chat/15min";
